// extracted by mini-css-extract-plugin
export default {"pageWrap":"md-z","fullWidth":"nd-z","heading":"od-z","fullBleed":"pd-z","hidden":"qd-z"};